import { __generator } from "tslib";
import { call, select, takeLatest } from 'redux-saga/effects';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { IMAGE_PRELOAD_BATCH_SIZE, PRELOADING_DEPTH, } from '../constants/screen';
import { getCurrentScreen, isImageLoadable } from '../selectors';
import getImagesToPreload from '../utils/getImageBatch';
import * as imgUtils from '../utils/image';
import * as status from '../constants/imagePreloading';
var actions = [
    actionTypes.LOAD_HOTSPOTS_DONE,
    actionTypes.SET_PROJECT,
    actionTypes.SHOW_SCREEN,
    actionTypes.SHOW_OVERLAY,
];
export default function preloadImages(dispatch) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // TODO: in the future we will need to support
            // partial project loading on embedded prototypes
            return [4 /*yield*/, takeLatest(actions, function () {
                    var currentScreen, project, screens, imageBatch, imagePreloadingStatus, imagesToPreload, batch;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, select(getCurrentScreen)];
                            case 1:
                                currentScreen = _a.sent();
                                return [4 /*yield*/, select(function (state) { return state.project; })];
                            case 2:
                                project = _a.sent();
                                screens = project.config.screens.filter(function (screen) {
                                    return isImageLoadable(screen);
                                });
                                if (process.env.NODE_ENV === 'test') {
                                    // Most tests reqiure _all_ images to be loaded
                                    imageBatch = screens.map(function (s) { return ({ id: s.id, url: s.img.url }); });
                                }
                                else {
                                    imageBatch = getImagesToPreload({
                                        screen: currentScreen,
                                        screens: screens,
                                        screenMap: project.config.screenMap,
                                        depth: PRELOADING_DEPTH,
                                    });
                                }
                                return [4 /*yield*/, select(function (state) { return state.imagePreloading; })];
                            case 3:
                                imagePreloadingStatus = _a.sent();
                                imagesToPreload = imageBatch.filter(function (image) {
                                    // TODO why does === IDLE here not work?
                                    return imagePreloadingStatus[image.id] !== status.DONE &&
                                        imagePreloadingStatus[image.id] !== status.PRELOADING;
                                });
                                _a.label = 4;
                            case 4:
                                if (!imagesToPreload.length) return [3 /*break*/, 6];
                                batch = imagesToPreload.splice(0, IMAGE_PRELOAD_BATCH_SIZE);
                                return [4 /*yield*/, call(imgUtils.preloadImages, {
                                        dispatch: dispatch,
                                        images: batch,
                                        successActionCreator: actionCreators.imageLoaded,
                                        failureActionCreator: actionCreators.imageLoadFailed,
                                        loadingStartActionCreator: actionCreators.imageLoadingStart,
                                    })];
                            case 5:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 6: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                // TODO: in the future we will need to support
                // partial project loading on embedded prototypes
                _a.sent();
                return [2 /*return*/];
        }
    });
}
